// ═══════════════════════════════════════════════════════════════════
//  layout/MobileDrawer.js
//  MobileDrawer
// ═══════════════════════════════════════════════════════════════════

import { BouxImg } from "../composants/BouxImg";
import { THEME } from "../socle/theme";
import { navItemsForRole } from "./navigation";

export function MobileDrawer({ open, onClose, active, onNavigate, user, onLogout }) {
  const items = navItemsForRole(user.role);
  return (
    <>
      <div onClick={onClose}
        style={{ position: "fixed", inset: 0, zIndex: 50, background: "rgba(0,0,0,0.55)", opacity: open ? 1 : 0, pointerEvents: open ? "auto" : "none", transition: "opacity .25s" }} />
      <div style={{ position: "fixed", top: 0, bottom: 0, left: 0, width: 248, maxWidth: "82%", zIndex: 51, background: THEME.surface, borderRight: `1px solid ${THEME.border}`, transform: open ? "translateX(0)" : "translateX(-100%)", transition: "transform .25s", display: "flex", flexDirection: "column" }}>
        <div style={{ padding: "18px 16px 14px", borderBottom: `1px solid ${THEME.border}`, display: "flex", alignItems: "center", gap: 10 }}>
          <span style={{ fontSize: 20, color: THEME.gold }}>✦</span>
          <BouxImg height={30} />
          <div>
            <div style={{ color: THEME.gold, fontWeight: 800, fontSize: 15, letterSpacing: 1 }}>ORIALIS</div>
            <div style={{ color: THEME.textMuted, fontSize: 10 }}>Intranet Staff</div>
          </div>
          <button onClick={onClose} aria-label="Fermer" style={{ marginLeft: "auto", background: "transparent", border: "none", color: THEME.textMuted, fontSize: 20, cursor: "pointer", padding: 4 }}>✕</button>
        </div>
        <nav style={{ flex: 1, padding: "12px 10px", display: "flex", flexDirection: "column", gap: 2, overflowY: "auto" }}>
          {items.map((item) => {
            const on = active === item.id;
            return (
              <button key={item.id} disabled={!item.ready} onClick={() => { if (item.ready) { onNavigate(item.id); onClose(); } }}
                style={{ background: on ? THEME.purpleDim : "transparent", border: `1px solid ${on ? THEME.purple : "transparent"}`, color: !item.ready ? THEME.textDim : on ? THEME.purple : THEME.textMuted, borderRadius: 8, padding: "11px 12px", display: "flex", alignItems: "center", gap: 10, cursor: item.ready ? "pointer" : "not-allowed", fontSize: 14, fontWeight: on ? 600 : 400, textAlign: "left", width: "100%", opacity: item.ready ? 1 : 0.5 }}>
                <span style={{ fontSize: 16 }}>{item.icon}</span>{item.label}
                {!item.ready && <span style={{ marginLeft: "auto", fontSize: 9, color: THEME.textDim }}>bientôt</span>}
              </button>
            );
          })}
        </nav>
        <div style={{ padding: "14px 16px", borderTop: `1px solid ${THEME.border}`, display: "flex", alignItems: "center", gap: 10 }}>
          <div style={{ width: 34, height: 34, background: THEME.accentDim, borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 15, fontWeight: 700, color: THEME.accent }}>
            {user.email[0].toUpperCase()}
          </div>
          <div style={{ overflow: "hidden" }}>
            <div style={{ color: THEME.text, fontSize: 12, fontWeight: 600, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{user.email}</div>
            <div style={{ color: THEME.gold, fontSize: 10, fontWeight: 600 }}>{user.role}</div>
          </div>
          <button onClick={onLogout} title="Déconnexion" style={{ marginLeft: "auto", background: "transparent", border: "none", color: THEME.textMuted, cursor: "pointer", fontSize: 16, padding: 4 }}>⏏</button>
        </div>
      </div>
    </>
  );
}
